var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ctcp" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("main", [_c("router-view")], 1),
    _vm._v(" "),
    _c("footer", [
      _c("a", { attrs: { href: _vm.$t("link.dataprivacy") } }, [
        _vm._v(_vm._s(_vm.$t("linklabel.dataprivacy")))
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: _vm.$t("link.impressum") } }, [
        _vm._v(_vm._s(_vm.$t("linklabel.impressum")))
      ])
    ]),
    _vm._v(" "),
    _vm.isProduction
      ? _c("img", {
          staticStyle: { border: "0" },
          attrs: { src: _vm.matomoUrl, alt: "" }
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ct-navbar-content" }, [
      _c("div", { staticClass: "ct-logo" }, [
        _c("img", { attrs: { src: "/images/ct-logo.png" } })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28c1148c", { render: render, staticRenderFns: staticRenderFns })
  }
}